(function () {
  const handle = window.__collection_handle || '';
  const isWomens = handle.includes('women');
  const isMens = handle.includes('men') && !handle.includes('women');
  if (!isWomens && !isMens) return;

  const keywords = isWomens
    ? ['girl', 'female', 'woman', 'women']
    : ['male', 'man', 'men', 'boy'];

  function matchesKeywords(src) {
    const filename = decodeURIComponent(src.split('/').pop().split('?')[0]).toLowerCase();
    return keywords.some(k => filename.includes(k));
  }

  function swapImages() {
    document.querySelectorAll('.card__media img').forEach(function(img) {
      const card = img.closest('.card-wrapper');
      if (!card) return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const productPath = link.getAttribute('href').split('?')[0];

      fetch(productPath + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          if (!product.images || !product.images.length) return;
          const match = product.images.find(function(src) { return matchesKeywords(src); });
          if (match) {
            img.src = match;
            img.srcset = '';
            img.removeAttribute('srcset');
          }
        })
        .catch(function(e) { console.log('GIS error:', productPath, e); });
    });
  }

  // Run immediately, on DOMContentLoaded, on load, and after a delay
  swapImages();
  document.addEventListener('DOMContentLoaded', swapImages);
  window.addEventListener('load', swapImages);
  setTimeout(swapImages, 1500);
  setTimeout(swapImages, 3000);
})();
